const getSiteValuefromLocation = () => {
  // used to ensure correct recaptcha token is used if site hasnt loaded from tealium yet.
  switch (window.location.hostname) {
    case "www.news.com.au":
      return "newscomau";
    case "www.codesports.com.au":
      return "cs";
    default:
      return "";
  }
};

// Get Context data for web environment from existing page js objects.
const getWebEnvData = () => {
  const ud = window.utag_data || {};
  // console.log("handleParams queryParamStr ud", ud.pc_memtype, window.utag_data);
  const capiMeta = document.querySelector('meta[name="articleid"]');
  const capiId =
    (capiMeta && capiMeta.getAttribute("content")) || ud.net_article_id;
  const capiUrl = window.location.href;
  const premiumStatus = ud.pc_conttyperule;
  const newsKey = ud.newskey; // window.newskey.nk, window.utag_data.newskey, ncg_data.device_id
  const userId =
    ud.pc_pcsid ||
    window.newscorpau?.auth?.["http://login.newscorpaustralia.com.au/profile"]
      ?.think_id; // window.utag_data.pc_pcsid, ncg_data.user_id
  const userAccessLevel = ud.pc_memtype; // window.utag_data.pc_memtype, ncg_data.user_memtype
  const site = ud.site_short || getSiteValuefromLocation();
  const section = ud.net_sec1; // window.utag_data.site_short

  if (window.location.search.match("debugEditorialTools")) {
    console.log("utag", window.utag_data, JSON.stringify(ud));
    console.log("site_short", ud.site_short, site);
    console.log(
      "newskey",
      window.newskey.nk,
      window.utag_data.newskey,
      window.ncg_data
    );
    console.log(
      "userId",
      window.utag_data.pc_pcsid,
      window.ncg_data,
      window.newscorpau?.auth?.["http://login.newscorpaustralia.com.au/profile"]
        ?.think_id
    );
    console.log(
      "userAccessLevel",
      window.utag_data.pc_memtype,
      window.ncg_data
    );
  }

  return {
    site,
    section,
    capiId,
    capiUrl,
    premiumStatus,
    userId,
    userAccessLevel,
    newsKey,
  };
};

const mapAmpBrand = (brand) => {
  const brandMap = {
    dailytelegraph: "dt",
    adelaidenow: "adv",
    couriermail: "cm",
    heraldsun: "hs",
    cairnspost: "cp",
    townsvillebulletin: "tb",
    ntnews: "ntn",
    goldcoastbulletin: "gcb",
    geelongadvertiser: "ga",
    mercury: "merc",
    weeklytimesnow: "wtn",
    theaustralian: "taus",
    thechronicle: "twc",
  };

  return brandMap[brand] || brand;
};

const matchValues = (str, regex, matchIndex = 0) => {
  const match = (str || "").match(regex);
  if (match && match[matchIndex]) {
    return match[matchIndex];
  }
};

export const getAmpEnvData = (meta) => {
  console.log(meta);

  const {
    net_site,
    net_sec1,
    net_article_id,
    net_article_headline,
    userId: _userId,
    userAccessLevel: _userAccessLevel,
    newsKey,
    capiId,
    capiUrl,
    section,
    brand,
    title,
    ...utagData
  } = meta || {};

  const site = net_site || mapAmpBrand(brand);
  const userId = matchValues(_userId, /^[0-9]{2,10}$/) || "none";
  const userAccessLevel =
    matchValues(_userAccessLevel, /^subscriber|registered|anonymous$/) ||
    "anonymous";

  // set any other values passed through directly to utag_data
  window.utag_data = utagData;

  console.log(
    "getAmpEnvData val",
    site,
    userId,
    userAccessLevel,
    window.utag_data
  );

  return {
    site,
    section: section || net_sec1,
    capiId: capiId || net_article_id,
    capiUrl: decodeURIComponent(capiUrl),
    // premiumStatus,
    userId,
    userAccessLevel,
    newsKey,
    title: title || net_article_headline,
  };
};

// Get the correct environment context data for current channel
export default function getDataForChannel(props) {
  const hasAppDiv = document.getElementById("screenkit--embed-container");
  // console.log("hasAppDiv", hasAppDiv);

  if (window.DNA_APP_ENV || hasAppDiv) {
    const data = window.DNA_APP_ENV || {};
    document.title = `Editorial Tools: ${props.type} - ${props.id}`;
    const body = document.querySelector("body");
    if (body) {
      body.classList.add("et_app_webview");
      if (data.site) body.classList.add(data.site);
    }

    return {
      ...data,
      ...props,
      channel: "app",
      isApp: true,
      loadTealium: data.site ? true : false,
      loadRampart: true,
    };
  } else if (window.DNA_AMP_ENV || props.isAmp) {
    return {
      ...(window.DNA_AMP_ENV || {}),
      ...props,
      channel: "amp",
      isAmp: true,
      loadTealium: true,
    };
  } else {
    return {
      ...getWebEnvData(),
      ...props,
      channel: "web",
      isWeb: true,
    };
  }
}
